import React from 'react';

import { PageTitle } from '../../../components';
import { Pricing } from '../..';



const PricingPage = () => {  
  return (   
    <> 

      {/* Page Title */}
      <PageTitle title={'Pricing'} page={'Pricing'} />
      
      {/* Pricing Section */}
      <Pricing />
      
    </>
  )
}

export default PricingPage;